<!--
  Swiper replaces <p-carousel>. The wrappers below are not decoration: they reproduce the
  layout PrimeNG produced, which Swiper's own controls do NOT match out of the box.
    - .p-carousel-content was `display:flex; flex-direction:row; gap:.25rem` with the
      prev/next buttons as real flex siblings of the viewport, so the arrows took
      horizontal space and narrowed the row of cards.
    - .p-carousel-indicator-list was a centred block BELOW the content, in normal flow.
  Swiper positions both absolutely OVER the slides instead, so the arrows and the bullets
  are rendered here as our own elements and handed to Swiper by reference. AB#83916.
-->
<div class="app-carousel">
  <div class="app-carousel--content">
    @if (showNavigation) {
      <button
        #prevEl
        type="button"
        class="app-carousel--nav app-carousel--nav-prev"
        aria-label="Previous"
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M9.61296 13C9.50997 13.0005 9.40792 12.9804 9.3128 12.9409C9.21767 12.9014 9.13139 12.8433 9.05902 12.7701L3.83313 7.54416C3.68634 7.39718 3.60388 7.19795 3.60388 6.99022C3.60388 6.78249 3.68634 6.58325 3.83313 6.43628L9.05902 1.21039C9.20762 1.07192 9.40416 0.996539 9.60724 1.00012C9.81032 1.00371 10.0041 1.08597 10.1477 1.22959C10.2913 1.37322 10.3736 1.56698 10.3772 1.77005C10.3808 1.97313 10.3054 2.16968 10.1669 2.31827L5.49496 6.99022L10.1669 11.6622C10.3137 11.8091 10.3962 12.0084 10.3962 12.2161C10.3962 12.4238 10.3137 12.6231 10.1669 12.7701C10.0945 12.8433 10.0083 12.9014 9.91313 12.9409C9.81801 12.9804 9.71596 13.0005 9.61296 13Z"
            fill="currentColor"
          />
        </svg>
      </button>
    }

    <div #swiperEl class="swiper app-carousel--viewport">
      <div class="swiper-wrapper">
        @for (item of items; track item) {
          <div class="swiper-slide">
            <app-carousel-item
              [item]="item"
              [order]="order"
            ></app-carousel-item>
          </div>
        }
      </div>
    </div>

    @if (showNavigation) {
      <button
        #nextEl
        type="button"
        class="app-carousel--nav app-carousel--nav-next"
        aria-label="Next"
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M4.38708 13C4.28408 13.0005 4.18203 12.9804 4.08691 12.9409C3.99178 12.9014 3.9055 12.8433 3.83313 12.7701C3.68634 12.6231 3.60388 12.4238 3.60388 12.2161C3.60388 12.0084 3.68634 11.8091 3.83313 11.6622L8.50507 6.99022L3.83313 2.31827C3.69467 2.16968 3.61928 1.97313 3.62287 1.77005C3.62645 1.56698 3.70872 1.37322 3.85234 1.22959C3.99596 1.08597 4.18972 1.00371 4.3928 1.00012C4.59588 0.996539 4.79242 1.07192 4.94102 1.21039L10.1669 6.43628C10.3137 6.58325 10.3962 6.78249 10.3962 6.99022C10.3962 7.19795 10.3137 7.39718 10.1669 7.54416L4.94102 12.7701C4.86865 12.8433 4.78237 12.9014 4.68724 12.9409C4.59212 12.9804 4.49007 13.0005 4.38708 13Z"
            fill="currentColor"
          />
        </svg>
      </button>
    }
  </div>

  @if (showNavigation) {
    <div #paginationEl class="app-carousel--pagination"></div>
  }
</div>
